import {SynchronousRegistry} from '@neos-project/neos-ui-extensibility/src/registry';

export default class RichTextToolbarRegistry extends SynchronousRegistry {
}
